import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  ChartDataLabels,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
);

ChartJS.defaults.font.size = 12;

export const chartConfig = ChartJS;
